<template>
  <Loader v-if="loading" />
  <div v-else>
    <div class="flex content">
      <h1>Orders assigned to {{ stylist.firstname }} {{ stylist.lastname }}</h1>
      <div class="flex-grow flex text-right"
        style="justify-content: flex-end; align-items: center;">
        <select
          v-model="stylist_id">
          <option
            v-for="stylist in stylistList"
            :value="stylist.id"
            :key="stylist.id"
            >{{ stylist.firstname }} {{ stylist.lastname }}</option
          >
        </select>
      </div>
    </div>

    <Loader class="extra-soft" :soft="true" v-if="soft_loading" />

    <div class="content">
      <StylistOrdersTable
        :stylist="stylist_id"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StylistOrdersTable from '@/components/orders/StylistOrdersTable.vue'

export default {
  data: () => ({
    loading: false,
    soft_loading: false,
    saving: false,
    stylist: {},
    stylist_id: 91
  }),
  watch: {
    stylist_id (newId) {
      for (var s of this.getStylists) {
        if (s.id === newId) {
          this.stylist = s
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getStylist', 'getStylists', 'getCountries']),
    stylistList () {
      return this.getStylists.filter(s => s.id !== 2)
    }
  },
  components: {
    StylistOrdersTable
  },
  methods: {
    updated() {
    },
    parse (data) {
      this.records = data
    },
    comments (row) {
      this.comments_editor = row.order_id ? row.order_id : (row.id ? row.id : row.ID)
    }
  },
  created () {
    this.stylist = this.getStylists.find(s => s.id === this.stylist_id)
  }
}
</script>
